export const environment = {
  production: true,
  upstreamServerEndPoint: "",
  backendEndPoint: "https://staging-elikita-auth-server-cnd5f4cnepcdb8d7.canadacentral-01.azurewebsites.net/fhir",
  patientBackendEndPoint: "https://elikita-nodejs-server-staging-hxfuh7g6csa9gkcx.canadacentral-01.azurewebsites.net/api/fhir",
  authBackendEndPoint: "https://staging-elikita-auth-server-cnd5f4cnepcdb8d7.canadacentral-01.azurewebsites.net",
  cloudinaryCloudName: 'dtrg3t7ea',
  cloudinaryUploadPreset: 'elikita_uploads',
  messagingFirebaseRoot: 'elikita-staging',
  features: {
    enableBackendPrint: false
  }
};
